// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"A2-z","colorTextValue":"B2-z","swatches":"C2-z","collapseLink":"D2-z","isCollapsed":"E2-z","dropdown":"F2-z","disabled":"G2-z"};